import React from "react";
import { connect } from "react-redux";

import axios from "../../axios-atis";

//import FileDownload from 'react-file-download';
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import { fetchDocuments } from "../../store/actions/index";
import ReactTable from "../../react-table-atis";
import { isA } from "../../store/utility";

import { Button, Row, Col, OverlayTrigger, Popover } from "react-bootstrap";

class DocumentList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      loading: true,
      pages: null,
      page: 0,
      pageSize: 20,
      sorted: null,
      filtred: null,
      showRequestModal: false,
      showNewRequestModal: false,
      selectedRow: null,
      company: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.loading &&
      !nextProps.loading &&
      null !== nextProps.documents &&
      null == nextProps.error
    ) {
      this.setState({
        loading: nextProps.loading,
        pages: nextProps.documents.length,
        data: nextProps.documents,
        company: nextProps.company
      });
    }
  }

  componentDidMount() {
    this.props.dispatch(fetchDocuments());
  }
  closeRequestModal = () => {
    this.setState({
      showRequestModal: false
    });
  };

  closeNewRequestModal = () => {
    this.setState({
      showNewRequestModal: false
    });
  };
  downloadFileHandler = (e, row) => {
    e.preventDefault();

    axios({
      url:
        "/files/download?path=" +
        row.original.path +
        "&fileName=" +
        row.original.fileName,
      method: "GET",
      responseType: "blob"
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", row.original.fileName);
      document.body.appendChild(link);
      link.click();
      //FileDownload(response.data, row.original.fileName);
    });
  };
  listFilesHandler = (e, row) => {
    e.preventDefault();

    this.setState({
      loading: true,
      data: []
    });
    this.props.dispatch(
      fetchDocuments(row.original.path + "/" + row.original.fileName)
    );
  };

  getFaIconSpan = mimeType => {
    var faClass = "fa ";
    if (mimeType === "image") {
      faClass += "fa-file-image-o";
    } else if (mimeType === "audio") {
      faClass += "fa-file-audio-o";
    } else if (mimeType === "video") {
      faClass += "fa-file-video-o";
    } else if (mimeType === "application/pdf") {
      faClass += "fa-file-pdf-o";
    } else if (mimeType === "text/plain") {
      faClass += "fa-file-text-o";
    } else if (mimeType === "text/html" || mimeType === "application/json") {
      faClass += "fa-file-code-o";
    } else if (
      mimeType === "application/gzip" ||
      mimeType === "application/zip"
    ) {
      faClass += "fa-file-archive-o";
    } else {
      faClass += "fa-file-o";
    }

    return <span className={faClass} />;
  };
  renderTable = () => {
    return (
      <ReactTable
        defaultFilterMethod={(filter, row) =>
          String(row[filter.id]) === filter.value
        }
        columns={[
          {
            Header: "",
            accessor: "dir",
            filterable: false,
            width: 32,
            Cell: row => (
              <div align="center">
                {row.value ? (
                  <span className="fa fa-folder" />
                ) : (
                  this.getFaIconSpan(row.original.mimeType)
                )}
              </div>
            )
          },

          { Header: "Nom", accessor: "fileName", filterable: false },
          {
            Header: "",
            accessor: "dir",
            filterable: false,
            width: 32,
            Cell: row => (
              <OverlayTrigger
                placement="left"
                overlay={
                  <Popover id="pp1">
                    {row.index === 0 && row.original.fileName === ".."
                      ? "Remonter au dossier parent"
                      : row.value
                      ? "Descendre dans le dossier " + row.original.fileName
                      : "Télécharger le fichier " + row.original.fileName}
                  </Popover>
                }
              >
                {row.index === 0 && row.original.fileName === ".." ? (
                  <span
                    onClick={e => this.listFilesHandler(e, row)}
                    className=" fa fa-toggle-up"
                    style={{ cursor: "n-resive" }}
                  />
                ) : row.value ? (
                  <span
                    onClick={e => this.listFilesHandler(e, row)}
                    className="fa fa-toggle-down"
                    style={{ cursor: "s-resive" }}
                  />
                ) : (
                  <span
                    onClick={e => this.downloadFileHandler(e, row)}
                    className="fa fa-cloud-download"
                    style={{ cursor: "pointer" }}
                  />
                )}
              </OverlayTrigger>
            )
          }
        ]}
        filterable
        sortable
        data={this.state.data}
        loading={this.state.loading}
        className="-striped -highlight"
      />
    );
  };
  render() {
    const { error } = this.props;
    if (error) {
      return <div>Erreur : {error.message}</div>;
    }
    return (
      <div className="content-wrapper">
        <Row className="form-group content-heading">
          <Col md={8}>Documents</Col>
          <Col md={4}>
            {isA() ? (
              <Button
                bsStyle="primary"
                className="pull-right"
                onClick={e => this.uploadDocumentHandler(e)}
              >
                <span className="fa fa-upload" />&nbsp;Envoyer un document
              </Button>
            ) : (
              ""
            )}
          </Col>
        </Row>
        {this.renderTable()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    documents: state.document.documents,
    error: state.document.error,
    loading: state.document.loading,
    userId: state.auth.userId,
    isAuthenticated: state.auth.token !== null,
    company: state.auth.company
  };
};

export default connect(mapStateToProps)(withErrorHandler(DocumentList, axios));



// WEBPACK FOOTER //
// ./src/containers/Document/DocumentList.js